import { apiInstance } from '@/api/api.js'
import { DEFAULT_LANGUAGE } from '../../helpers/constants'
const api = apiInstance()

export default {
  async getBhUsers({ state, commit, dispatch }, params) {
    params = params || state.bhUsersFilters
    try {
      commit('setLoading', true)
      const response = await api.get('/bhUsers', { params })
      commit('setBhUsersFilters', params)
      commit('setBhUsers', response.data.bhUsers)
      commit('setPagination', response.data._meta)
      commit('setLoading', false)
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },

  async getBhUser({ commit, dispatch }, id) {
    const url = `/bhUsers/${id}`

    try {
      commit('setLoading', true)
      const response = await api.get(url)
      commit(
        'headersStates/setHeadersEtag',
        { headers: response.headers, url },
        { root: true },
      )
      commit(
        'appStates/setBreadcrumbCurrentView',
        response.data.firstName + ' ' + response.data.lastName,
        { root: true },
      )
      commit('setBhUser', response.data)
      commit('setLoading', false)
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },

  async getBhUserPatients({ commit, dispatch }, id) {
    try {
      commit('setLoading', true)
      const response = await api.get(`/participants?consultantId=${id}`)
      commit('setBhUserPatients', response.data)
      commit('setPagination', response.data._meta)
      commit('setLoading', false)
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },

  async addBhUser({ commit, dispatch }, data) {
    try {
      commit('setLoading', true)
      await api.post('/bhUsers', data)
      await dispatch('getBhUsers')
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'New user added!', {
        root: true,
      })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },

  async changeBhUserField(
    { state, commit, rootState, dispatch },
    { id, key, value },
  ) {
    const url = `/bhUsers/${id}`

    try {
      const { headersStates } = rootState

      commit('setLoading', true)
      const response = await api.put(
        url,
        {
          ...state.bhUser,
          language: state.bhUser.language || DEFAULT_LANGUAGE,
          [key]: value,
        },
        { headers: { 'If-Match': headersStates.headersEtag[url] } },
      )
      commit('setBhUser', response.data)
      commit(
        'appStates/setBreadcrumbCurrentView',
        response.data.firstName + ' ' + response.data.lastName,
        { root: true },
      )
      commit(
        'headersStates/setHeadersEtag',
        { headers: response.headers, url },
        { root: true },
      )
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Saved!', { root: true })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },

  async generateSurrogateAuthToken(
    { commit },
    { userProfileId, type = 'SURROGATE_AUTHENTICATION', username },
  ) {
    const url = `/profiles/${userProfileId}/tokens`
    let payload = {}
    if (type == 'SURROGATE_AUTHENTICATION') {
      payload = {
        type,
        surrogate: username,
      }
    } else {
      payload = {
        type,
      }
    }

    try {
      commit('setLoading', true)
      const response = await api.post(url, payload)
      commit('setLoading', false)
      return response.data
    } catch (error) {
      commit('setLoading', false)
      throw error
    }
  },
}
